var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticStyle:{"height":"100%"}},[_c('keep-alive',[(_vm.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.show)?_c('div',[_vm._v(" 当前没有选择项目，请选择项目进行操作")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }